// eslint-disable-next-line import/no-unresolved
import brand from '@brand/brand.js';
import { Trans, useTranslation } from 'react-i18next';
import { BrandedLayout } from '../components/layouts/branded-layout';
import { InfoBlock } from '../components/ui/info-block';
import { cleanPhone } from '../utils/phone';

export function InvalidInvite() {
  const { t } = useTranslation('page.invalid-invite');
  return (
    <BrandedLayout>
      <h1 className="title text-error-500">{t('title')}</h1>
      <InfoBlock>
        <Trans
          i18nKey="helpMessage"
          ns="page.invalid-invite"
          values={{ phone: brand.phone }}
          components={{
            h3: <h3 className="subtitle mb-0" />,
            p: <p />,
            br: <br />,
            strong: <strong className="font-semibold" />,
            a: <a href={`tel:${cleanPhone(brand.phone)}`} />,
          }}
        />
      </InfoBlock>
    </BrandedLayout>
  );
}
